export class ItemIdReq{
    itemId:number;
    unitId:number;
    locationId?:number;
    stockType?:string;
    saleOrderId?:number
}